import Module, { ViewLayer, moduleInit, bindButtonClickEvent, bindToggleClickEvent } from "../../../../framework/core/mvvm/module_base";
import ActivityUtil from "../activity/activity_util";
import ModuleManager from "../../../../framework/core/module_manager";
import { AutoDialogManager } from "../../../../manager/auto_dialog_manager";
import VideoRewardView from "./videoreward_view";
import AppController from "../../../../sdk/app_controller";
import AppData from "../../../public/const/app_data";
import Utility from "../../../../utility/utility";
import { RedPointModule } from "../../../public/component/redpoint_component";
import AudioManager from "../../../../manager/audio_manager";
import ModelData from "../../../public/model_data";

const {ccclass, property} = cc._decorator;

@ccclass
@moduleInit("VideoReward")
export default class VideoReward extends Module<VideoRewardView,null> {
    activityData:any = {}
    
    static _lastWatchVideoAdertTime = 0

    static _lastGetRewardTime = 0

    _getAdvertWithGoogle = true

    //是否使用测试广告
    private testAd = true

    private showAdAndCanGetReward = false


    constructor() {
        super();
        this.layer = ViewLayer.Mid;
        this.windowPrefabResPath = "package/hall/module/videoreward/hall_videoreward";
        this.viewType = VideoRewardView
        this.modelType = null
        this.autoShowAnim = true
        this.needAnim = true
        this.needViewMask = true
        this.needViewBaseCloseBtn = true;
        this.needDeferShow = true
    }

    onInit(intenData){
        if (AppData.userConnectEnvi == 0) {
            this.testAd = false
        }

        if (CC_JSB ) {
            // if (this._getAdvertWithGoogle) {
            //     AppController.instance.requestNativeFuncReturn("loadGoogleRewardAd", this.getRewardAdProductId(true, this.testAd))
            // } else {
            //     AppController.instance.requestNativeFuncReturn("loadFacebookRewardAd", this.getRewardAdProductId(false, this.testAd))
            // }
        }

        // VideoReward._lastGetRewardTime = new Date().getTime()
        cc.log("Advert._lastWatchVideoAdertTime：", VideoReward._lastGetRewardTime)
    }

    onDeferShow(intenData) {
        let self = this
        self.unscheduleAllCallbacks()
        // this._getAdvertWithGoogle = Math.random() < 0.5
        this._getAdvertWithGoogle = false

        this.getData(function(data){
            self.view.initData(self.activityData)
            self.view.setProgressData(self.activityData)
            self.show();
        })
    }

    private getData(finish:Function){
        let self = this;
        ActivityUtil.getAdvertActivity(function(data){
            let activityId = data.activityId;
            self.activityData = {}
            let awards = []
            if (data.awards.length == 0) {
                ModuleManager.instance.toastKey("purchase_not_open");
                return
            }
            self.activityData.awards = awards;
            self.activityData.dayNum = data.dayNum;
            //都会统一减去12秒，前面的12秒是预留给服务的广告时间
            self.activityData.cdSecond = Math.max(0, data.cdSecond - 12) * 1000;
            self.activityData.activityId = activityId;
            self.activityData.todayNum = data.progress.todayNum;
            self.activityData.isFinish = data.progress.isFinish;
            self.activityData.lastGetRewardTime = VideoReward._lastGetRewardTime
            for (let award of data.awards) {
                awards.push(award);
            }

            awards.sort((a:any,b:any)=>{
                return a.activityConditionGroup - b.activityConditionGroup;
            })

            if (activityId != undefined) {
                finish && finish(self.activityData);
            }else{
                self.hide();
            }
            
        }, self);
    }

    private on_draw_award(data){
        let self = this
        // ActivityUtil.getAdvertActivityProgress(self.activityData.activityId, function(data){
        //     //当前进度
        //     self.activityData.isCanAward = data.isReceive;//可以领取
        //     self.activityData.isFinish = data.isFinish;
        //     self.activityData.todayNum = data.todayNum
        // }, null, self)
        self.getSelfCurrencyData(null, true)
        let chipNum = 0
        let goldNum = 0
        if(data && data.length > 0){
            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                if (element.activityAmountType == 5){
                    chipNum += Number(element.amount)
                } else if(element.activityAmountType == 6){
                    goldNum += Number(element.amount)
                }
            }            
            ModuleManager.instance.showModuleName('DialogReceive', {chipNum: chipNum, goldNum: goldNum})
        }
        self.activityData.todayNum += 1
        self.activityData.isFinish = self.activityData.dayNum - self.activityData.todayNum <= 0
        if (self.activityData.isFinish) {
            this.eventDispatch('Event_Notify_RedPoint_Change_Refresh', RedPointModule.VideoReward, 0)
        }
        VideoReward._lastGetRewardTime = new Date().getTime()
        self.activityData.lastGetRewardTime = VideoReward._lastGetRewardTime
        self.view.setProgressData(self.activityData)
    }

    @bindButtonClickEvent('ButtonGetReward')
    onButtonGetReward() {
        let self = this
        this.showNetPrompt(true)
        if (self.showAdAndCanGetReward) {
            self.requestDrawActivityAward()
            return
        }
        Utility.reportEffect(`game_videoreward_open_` + (this._getAdvertWithGoogle ? "google" : "facebook"))
        AppController.instance.showRewardAd(this._getAdvertWithGoogle, this.getRewardAdProductId(this._getAdvertWithGoogle, this.testAd), (errorCode) => {
            if (errorCode) {
                self.showNetPrompt(false)
                if (self._getAdvertWithGoogle && errorCode == 3) {
                    cc.log("谷歌没有提供广告")
                    self._getAdvertWithGoogle = false
                } else if(self._getAdvertWithGoogle) {  //facebook
                    self._getAdvertWithGoogle = true
                }
                Utility.reportEffect(`game_videoreward_${self._getAdvertWithGoogle ? "google" : "facebook"}_errorCode_${errorCode}`)
                return 
            }
            Utility.reportEffect(`game_videoreward_finish` + (self._getAdvertWithGoogle ? "google" : "facebook"))
            cc.log("可以领取奖励")
            self.requestDrawActivityAward()
        })
    }

    @bindButtonClickEvent('CloseBtn')
    onButtonClose() {
        this.hide()
    }
    

    @bindToggleClickEvent('ToggleGoogle|ToggleFacebook')
    onToggleGoogle(toggle : cc.Toggle) {
        cc.warn(toggle)
        this._getAdvertWithGoogle = toggle.node.name == "ToggleGoogle" ? true : false
    }

    private requestDrawActivityAward() {
        let self = this
        self.showAdAndCanGetReward = true
        self.showNetPrompt(true)
        ActivityUtil.requestDrawActivityAward(self.activityData.activityId, function(data){
            self.showAdAndCanGetReward = false
            self.showNetPrompt(false)
            self.on_draw_award(data)
        }, (error) => {
            //{"code":"L_00027","msg":"การดำเนินการไม่ว่าง โปรดลองอีกครั้งในภายหลัง","detail":"操作繁忙请稍后再试"}
            self.showNetPrompt(false)
        }, self, true)
    }

    private getRewardAdProductId(userGoogleAd, test) {
        if (CC_JSB) {
            let adParameter = userGoogleAd ? AppData.adParameter.google : AppData.adParameter.facebook
            if (userGoogleAd && test) {
                return cc.sys.os == cc.sys.OS_ANDROID ? adParameter["anroidTest"] : adParameter["iosTest"]
            }
            return cc.sys.os == cc.sys.OS_ANDROID ? adParameter.anroid : adParameter.ios
        }
    }
    
    onHide() {
        this.view.reset()
        AppController.instance.clearVideoAdertRewardCallback()
        Utility.isNativeIOS() && AudioManager.instance.resumeMusic()
    }

}
